
import { useEffect } from "react"
import DatosProducto from "../../../../EmitirFactura/Components/GeneracionFactura/DatosProducto"
import TablaBienesServicios from "../../../../EmitirFactura/Components/GeneracionFactura/TablaBienesServicios"
import Footer from "../../Footer"
import FormDocV1 from "../forms/FormDocV1"
import FormProductosV1 from "../forms/productos/FormProductosV1"
import { useDispatch } from "react-redux"
import { facturacionFormClienteHandleChange } from "../../../../../actions/facturacion/facturacionCliente.actions"
import { facturacionClearAll } from "../../../../../actions/facturacion/facturacionEmision.actions"

export const CreditoFiscal = () => {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(facturacionClearAll(true))
    dispatch(facturacionFormClienteHandleChange({nombreTipoDocumento: 'NIT'}))
    dispatch(facturacionFormClienteHandleChange({tipoDocumento: '36'}))
  }, [])

  return (
    <>
      <FormDocV1 />
      <FormProductosV1 doc="3" />
      <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6' className='w-layout-cell'>
        <div className='card'>
          <div className='w-layout-vflex card-content'>
            <TablaBienesServicios />
            <Footer />
          </div>
        </div>
      </div>
    </>
  )
}
